export default "__VITE_ASSET__3499c367__"